module.exports = __webpack_public_path__ + "img/key.e91dbf4d.png";